import React from "react";
import "./typing-indicator.scss";

const TypingIndicator = () => {
  return (
    <main className="mds-container">
      <div className="mds-grid mds-grid-cols-1 mds-align-items-center">
        <div className="mds-column">
          <div className="typing-indicator">
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
            <div className="typing-dot"></div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default TypingIndicator;
